import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-move',
  templateUrl: './banner-move.component.html',
  styleUrls: ['./banner-move.component.css']
})
export class BannerMoveComponent implements OnInit {
  destinationFlag: string = '';
  destinationCountry: string = '';
  countryClass: string = '';

  constructor() {}

  ngOnInit() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user && user.country && user.country[0]) {
        const countryId = user.country[0].idCountry;
        // Asignar la bandera y el logo según el ID del país
        switch(countryId) {
          case 1: // Chile
            this.destinationFlag = 'assets/img/flags/chile.svg';
            this.destinationCountry = 'Chile';
            this.countryClass = 'shadow-logo chile';
            break;
          case 2: // Perú
            this.destinationFlag = 'assets/img/flags/peru.svg';
            this.destinationCountry = 'Perú';
            this.countryClass = 'shadow-logo peru';
            break;
          case 3: //Colombia
            this.destinationFlag = 'assets/img/flags/colombia.svg';
            this.destinationCountry = 'Colombia';
            this.countryClass = 'shadow-logo colombia';
            break;
          case 4: //mexico
            this.destinationFlag = 'assets/img/flags/mexico.svg';
            this.destinationCountry = 'México';
            this.countryClass = 'shadow-logo mexico';
            break;
          case 5: //Argentina
            this.destinationFlag = 'assets/img/flags/argentina.svg';
            this.destinationCountry = 'Argentina';
            this.countryClass = 'shadow-logo argentina';
            break;  
          default:
            this.destinationFlag = 'assets/img/flags/chile.svg';
            this.destinationCountry = 'Chile';
            this.countryClass = 'shadow-logo chile';
        }
      }
    }
  }
}
